import { Avatar, Text, Menu, MenuTrigger, MenuList, MenuItem, MenuPopover } from '@fluentui/react-components';
import { GridDots20Regular, Settings20Regular, PeopleTeam20Regular, ReadingModeMobile20Regular, AddCircle20Filled, ChevronDown12Regular } from '@fluentui/react-icons';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { GetProjectData, resetProjectData, selectProject, setProjectImg } from '../../../redux/projectDataSlice';
import { useLocation, useNavigate } from 'react-router';
import Cookies from 'js-cookie';
import { resetDocumentData, setDocs } from '../../../redux/documentsSlice';
import { logoutWithAudit, setActiveWorkspaceId, setWorkspaceSelectionRequired } from '../../../redux/usersSlice';
import logo from '../../../assets/longLogoBright.png';
import { resetObservationData } from '../../../redux/meetingSlice';
import { resetDataroomData } from '../../../redux/dataroomSlice';
import { resetNdaData } from '../../../redux/ndaSlice';
import { resetQestionBankData } from '../../../redux/questionBankSlice';
import { resetTaskData } from '../../../redux/taskSlice';
import { resetTeamData } from '../../../redux/teamSlice';
import React from 'react';
import { NotepadSidebar } from '../HeaderSidebars';
import { ObservationFormSidebar } from '../../Observations';
import { PostInformationRequestSidebar } from '../../IRL';
import { TaskFormSidebar } from '../../TasksInterface';
import GeneralGPTChatDrawer from '../../UserSettings/GeneralGPTChatDrawer';
const Header = ({ hideProjectItems, minimal = false }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedProject } = useSelector(state => state?.projectData);
    const { user } = useSelector(state => state?.user);
    const memberships = useSelector(state => state?.user?.memberships || []);
    const activeWorkspaceIdFromState = useSelector(state => state?.user?.activeWorkspaceId);
    const fallbackWorkspaceId = !activeWorkspaceIdFromState && memberships && memberships.length === 1 ? memberships[0]?.workspace?.id : null;
    const effectiveWorkspaceId = activeWorkspaceIdFromState || fallbackWorkspaceId;
    const activeMembership = memberships.find(m => m?.workspace?.id === effectiveWorkspaceId) || (memberships && memberships.length === 1 ? memberships[0] : undefined);
    const isWorkspaceSuperAdmin = activeMembership?.role === 'WORKSPACE_SUPER_ADMIN';
    const isProjectAdmin = selectedProject?.vdr?.vdr_admin === user?.id || selectedProject?.project_admins?.some(admin => admin.user_id === user?.id);

    const [notepadModal, setNotepadModal] = React.useState(false);
    const [questionModal, setQuestionModal] = React.useState(false);
    const [obsModal, setObsModal] = React.useState(false);
    const [taskModal, setTaskModal] = React.useState(false);
    const [showGeneralChat, setShowGeneralChat] = React.useState(false);
    const handleNavigateToProject = () => {
        dispatch(selectProject({ id: null }));
        dispatch(GetProjectData());
        navigate('/project');
        dispatch(resetObservationData());
        dispatch(resetDataroomData());
        dispatch(resetDocumentData());
        dispatch(resetNdaData());
        dispatch(resetProjectData());
        dispatch(resetQestionBankData());
        dispatch(resetTaskData());
        dispatch(resetTeamData());
    };
    const handleLogout = async () => {
        localStorage.removeItem('persist:root');
        Cookies.set('refresh', '');
        dispatch(setProjectImg(''));
        dispatch(setDocs([]));
        dispatch(resetQestionBankData()); // Reset IRL AI responses on logout
        await dispatch(logoutWithAudit());
        navigate('/');
    };

    const handleChangeWorkspace = () => {
        // Force workspace selection: user should not be able to navigate elsewhere until they pick.
        try {
            localStorage.removeItem('project_id');
        } catch (e) {}

        dispatch(setActiveWorkspaceId(''));
        dispatch(setWorkspaceSelectionRequired(true));
        dispatch(selectProject({ id: null }));
        dispatch(resetObservationData());
        dispatch(resetDataroomData());
        dispatch(resetDocumentData());
        dispatch(resetNdaData());
        dispatch(resetProjectData());
        dispatch(resetQestionBankData());
        dispatch(resetTaskData());
        dispatch(resetTeamData());

        navigate('/select-workspace');
    };

    if (minimal) {
        return (
            <>
                <div className={styles.header}>
                    <div className={styles.leftContent}>
                        <img onClick={() => navigate('/project')} role="button" src={logo} alt="lens-logo" className={styles.lensLogo} />
                    </div>
                    <div className="d-flex align-items-center">
                        <Menu>
                            <MenuTrigger disableButtonEnhancement>
                                <Avatar role="button" name={user?.full_name} aria-label="Guest" active="active" color="beige" />
                            </MenuTrigger>
                            <MenuPopover>
                                <MenuList>
                                    <MenuItem onClick={() => navigate('/user-settings')}>User Settings</MenuItem>
                                    {isWorkspaceSuperAdmin && effectiveWorkspaceId && (
                                        <MenuItem onClick={() => navigate(`/workspace-settings/${effectiveWorkspaceId}`)}>Workspace Settings</MenuItem>
                                    )}
                                    <MenuItem
                                        onClick={() => {
                                            setShowGeneralChat(true);
                                        }}>
                                        Ask Lens AI
                                    </MenuItem>
                                    <MenuItem>
                                        <a href="mailto:LensSupport@beyond-ma.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            Contact Support
                                        </a>
                                    </MenuItem>
                                    {memberships.length > 1 && <MenuItem onClick={handleChangeWorkspace}>Change Workspace</MenuItem>}
                                    <MenuItem onClick={handleLogout}>Logout </MenuItem>
                                </MenuList>
                            </MenuPopover>
                        </Menu>
                    </div>
                </div>
                <GeneralGPTChatDrawer show={showGeneralChat} setShow={setShowGeneralChat} />
            </>
        );
    }
    return (
        <>
            <div className={styles.header}>
                <div className={styles.leftContent}>
                    {!hideProjectItems && <GridDots20Regular onClick={handleNavigateToProject} role="button" color="white" />}

                    <img onClick={handleNavigateToProject} role="button" src={logo} alt="lens-logo" className={styles.lensLogo} />

                    {!minimal && selectedProject?.project_name && (
                        <div className={styles.inputNameDiv}>
                            {' '}
                            <Text onClick={() => navigate(user?.has_diligence_tools ? '/overview' : '/dataroom')} role="button" as="p" font="Inter" className={styles.projectName}>
                                {selectedProject?.project_name}
                            </Text>
                            {/* {!hideProjectItems && (
                                <Input
                                    style={{ borderRadius: 16 }}
                                    appearance="filled-lighter"
                                    contentBefore={<Search20Regular aria-label="Enter by voice" />}
                                    className={styles.searchInput}
                                />
                            )} */}
                        </div>
                    )}
                </div>
                <div>
                    {!hideProjectItems && (
                        <>
                            <QuickAddMenu setObsModal={setObsModal} setQuestionModal={setQuestionModal} setTaskModal={setTaskModal} setNotepadModal={setNotepadModal} />
                            <Menu>
                                <MenuTrigger disableButtonEnhancement>
                                    <div style={{ height: 27 }} className="d-inline-block" role="button">
                                        <Settings20Regular className={styles.settingLogo} color="white" />
                                    </div>
                                </MenuTrigger>
                                <MenuPopover>
                                    <MenuList>
                                        <MenuItem onClick={() => navigate('/EditProject')}>
                                            <div className="ps-1 pe-1">
                                                <Settings20Regular />
                                                <Text as="p" font="Inter" className={styles.menuLinkText}>
                                                    Project Settings
                                                </Text>
                                            </div>
                                        </MenuItem>
                                        {isProjectAdmin && (
                                            <MenuItem onClick={() => navigate('/team/vdr')}>
                                                <div className="ps-1 pe-1">
                                                    <PeopleTeam20Regular />
                                                    <Text as="p" font="Inter" className={styles.menuLinkText}>
                                                        Teams
                                                    </Text>
                                                </div>
                                            </MenuItem>
                                        )}

                                        {isProjectAdmin || selectedProject?.vdr?.nda ? (
                                            <MenuItem onClick={() => navigate(selectedProject?.vdr?.nda ? '/nda' : '/uploadnda')}>
                                                <div className="ps-1 pe-1">
                                                    <ReadingModeMobile20Regular />
                                                    <Text as="p" font="Inter" className={styles.menuLinkText}>
                                                        Project NDA
                                                    </Text>
                                                </div>
                                            </MenuItem>
                                        ) : (
                                            <MenuItem>
                                                <div className="ps-1 pe-1">
                                                    <Text as="p" font="Inter" className={styles.menuLinkText}>
                                                        No NDA uploaded
                                                    </Text>
                                                </div>
                                            </MenuItem>
                                        )}
                                    </MenuList>
                                </MenuPopover>
                            </Menu>
                        </>
                    )}
                    {!minimal && (
                        <span role="button" className="me-4" onClick={() => navigate('/cross-project-tasks')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 30 30" fill="none">
                                <path
                                    d="M11.9129 6.36835C12.279 6.73448 12.279 7.32807 11.9129 7.69418L8.63165 10.9753C8.2772 11.3297 7.70664 11.3426 7.33652 11.0046L5.93027 9.72019C5.54796 9.37102 5.5211 8.77804 5.87028 8.39573C6.21945 8.01342 6.81243 7.98656 7.19474 8.33573L7.93942 9.01587L10.5871 6.36832C10.9532 6.00221 11.5468 6.00223 11.9129 6.36835ZM11.9129 17.0692C12.279 16.7031 12.279 16.1095 11.9129 15.7434C11.5468 15.3772 10.9532 15.3772 10.5871 15.7433L7.93942 18.3909L7.19474 17.7107C6.81243 17.3616 6.21945 17.3884 5.87028 17.7707C5.5211 18.153 5.54796 18.746 5.93027 19.0952L7.33652 20.3796C7.70664 20.7176 8.2772 20.7047 8.63165 20.3503L11.9129 17.0692ZM15 7.5C14.4822 7.5 14.0625 7.91973 14.0625 8.4375C14.0625 8.95527 14.4822 9.375 15 9.375H19.6875C20.2053 9.375 20.625 8.95527 20.625 8.4375C20.625 7.91973 20.2053 7.5 19.6875 7.5H15ZM0 5.625C0 2.5184 2.5184 0 5.625 0H20.625C23.7316 0 26.25 2.5184 26.25 5.625V12.3769C25.6522 12.0718 25.0243 11.825 24.375 11.6409V5.625C24.375 3.55393 22.6961 1.875 20.625 1.875H5.625C3.55393 1.875 1.875 3.55393 1.875 5.625V20.625C1.875 22.6961 3.55393 24.375 5.625 24.375H11.6409C11.8246 25.0228 12.0711 25.6508 12.3769 26.25H5.625C2.5184 26.25 0 23.7316 0 20.625V5.625Z"
                                    fill="white"
                                />
                                <path
                                    d="M20.4687 14.0634C20.8394 13.3122 21.9105 13.3122 22.2813 14.0634L24.2829 18.119L28.7586 18.7694C29.5875 18.8899 29.9185 19.9085 29.3187 20.4932L26.08 23.6501L26.8446 28.1078C26.9862 28.9334 26.1196 29.5629 25.3782 29.1731L21.375 27.0685L17.3718 29.1731C16.6304 29.5629 15.7638 28.9334 15.9054 28.1078L16.67 23.6501L13.4313 20.4932C12.8315 19.9085 13.1625 18.8899 13.9914 18.7694L18.4671 18.119L20.4687 14.0634Z"
                                    fill="#FFC107"
                                />
                            </svg>
                        </span>
                    )}
                    <Menu>
                        <MenuTrigger disableButtonEnhancement>
                            <Avatar role="button" name={user?.full_name} aria-label="Guest" active="active" color="beige" />
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                <MenuItem onClick={() => navigate('/user-settings')}>User Settings</MenuItem>
                                {isWorkspaceSuperAdmin && effectiveWorkspaceId && (
                                    <MenuItem onClick={() => navigate(`/workspace-settings/${effectiveWorkspaceId}`)}>Workspace Settings</MenuItem>
                                )}
                                <MenuItem
                                    onClick={() => {
                                        setShowGeneralChat(true);
                                    }}>
                                    Ask AI
                                </MenuItem>
                                <MenuItem>
                                    <a href="mailto:LensSupport@beyond-ma.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        Contact Support
                                    </a>
                                </MenuItem>
                                {memberships.length > 1 && <MenuItem onClick={handleChangeWorkspace}>Change Workspace</MenuItem>}
                                <MenuItem onClick={handleLogout}>Logout </MenuItem>
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                </div>
            </div>
            <GeneralGPTChatDrawer show={showGeneralChat} setShow={setShowGeneralChat} />
            {notepadModal && <NotepadSidebar show={notepadModal} setShow={setNotepadModal} />}
            <ObservationFormSidebar show={obsModal} setShow={setObsModal} />
            <PostInformationRequestSidebar show={questionModal} setShow={setQuestionModal} />
            <TaskFormSidebar show={taskModal} setShow={setTaskModal} />
        </>
    );
};

export const QuickAddMenu = ({ setObsModal, setQuestionModal, setTaskModal, setNotepadModal }) => {
    const location = useLocation();
    const { selectedProject } = useSelector(state => state?.projectData);
    const { user } = useSelector(state => state?.user);
    return (
        selectedProject &&
        location?.pathname !== '/project' &&
        user?.has_diligence_tools && (
            <Menu style={{ marginTop: '20px' }}>
                <MenuTrigger disableButtonEnhancement>
                    <div style={{ height: 27 }} className="d-inline-block" role="button">
                        <AddCircle20Filled color="white" />
                        <ChevronDown12Regular color="white" />
                    </div>
                </MenuTrigger>
                <MenuPopover>
                    <MenuList>
                        <MenuItem onClick={() => setObsModal(true)}>
                            <Text as="p" font="Inter" className={styles.menuLinkText}>
                                Add Observation
                            </Text>
                        </MenuItem>
                        <MenuItem onClick={() => setQuestionModal(true)}>
                            <Text as="p" font="Inter" className={styles.menuLinkText}>
                                Add Information Request
                            </Text>
                        </MenuItem>
                        <MenuItem onClick={() => setTaskModal(true)}>
                            <Text as="p" font="Inter" className={styles.menuLinkText}>
                                Add Task
                            </Text>
                        </MenuItem>
                        <MenuItem onClick={() => setNotepadModal(true)}>
                            <Text as="p" font="Inter" className={styles.menuLinkText}>
                                Add Journal Entry
                            </Text>
                        </MenuItem>
                    </MenuList>
                </MenuPopover>
            </Menu>
        )
    );
};

export default Header;
